// noinspection TypeScriptValidateTypes

import 'vuetify/styles'
import { aliases, fa } from 'vuetify/iconsets/fa-svg'
import { createVuetify } from 'vuetify'
import { useI18n } from "vue-i18n";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import i18n from "@/plugins/i18n";

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    defaultTheme: 'dark',
    themes: {
      dark: {
        colors: {
          background: "#0c111b",
          surface: "#2b374b",
          primary: "#D51F27",
          "primary-darken-1": "#D51F27",
          secondary: "#C3D1FF",
          "secondary-darken-1": "#A0A3BD",
          error: "#B00020",
          info: "#FFFFFF",
          success: "#4CAF50",
          warning: "#FB8C00"
        },
      },
    },
  },
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n }),
  },
  icons: {
    defaultSet: 'fa',
    aliases,
    sets: {
      fa
    },
  },
})
